<template>
    <div class="side-bar">
        <v-sheet class="main-content" height="100%">
            <div class="menu-content">
                <div class="d-flex justify-content-start align-items-start" style="gap: 15px">
                    <img class="icons" src="../../../assets/img/s-1.svg" height="39" width="34" alt="INVESTOR - icon" />
                    <div>
                        <div class="text-left">
                            <h2 class="mb-3 menu-title">INVESTOR</h2>
                        </div>
                        <div class="text-left">
                            <div class="item" :class="$store.state.page == 'mainContact' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('mainContact')">Main contacts</div>
                            <div class="item mt-1" :class="$store.state.page == 'legalRepresentative' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('legalRepresentative')">Legal Representative</div>
                            <div class="item mt-1" :class="$store.state.page == 'accreditation' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('accreditation')">Accreditation</div>
                            <div class="item mt-1" :class="$store.state.page == 'investment_strategy' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('investment_strategy')">Investment Strategy</div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-start mt-14" style="gap: 15px">
                    <img class="icons" src="../../../assets/img/s-2.svg" height="30" width="30" alt="SOURCING - icon" />
                    <div>
                        <div class="text-left">
                            <h2 class="mb-3 menu-title">SOURCING</h2>
                        </div>
                        <div class="text-left">
                            <div class="item main-contacts" :class="$store.state.page == 'findNewDeals' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('findNewDeals')">Find new deals</div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-start mt-14" style="gap: 15px">
                    <img class="icons" src="../../../assets/img/s-2.svg" height="30" width="30" alt="SOURCING - icon" />
                    <div>
                        <div class="text-left">
                            <h2 class="mb-3 menu-title">DEAL FLOW</h2>
                        </div>
                        <div class="text-left">
                            <div class="item main-contacts" :class="$store.state.page == 'followUp' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('followUp')">Follow up</div>
                            <div class="item main-contacts" :class="$store.state.page == 'investments' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('investments')">Investments</div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-start mt-14" style="gap: 15px">
                    <img class="icons" src="../../../assets/img/s-3.svg" height="30" width="30" alt="ADMIN - icon" />
                    <div>
                        <div class="text-left">
                            <h2 class="mb-3 menu-title">ADMIN PANEL</h2>
                        </div>
                        <div class="text-left">
                            <div class="item" :class="actual == 'InitialApplication' ? 'active font-weight: bold' : ''" @click.prevent.stop="openAlertPopup('initial', 'investor')">Initial Application</div> <!-- actual = 'InitialApplication' -->
                            <div class="item mt-1" :class="actual == 'UpdatedApplication' ? 'active font-weight: bold' : ''" @click.prevent.stop="openAlertPopup('updated', 'investor')">Updated Application</div> <!--, actual = 'UpdatedApplication' -->
                            <div class="item mt-1" :class="$store.state.page == 'AccountStatus' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('AccountStatus')">Account Status</div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-start align-items-start mt-14" style="gap: 15px">
                    <img class="icons" src="../../../assets/img/s-4.svg" height="30" width="30" alt="BILLING - icon" />
                    <div>
                        <div class="text-left">
                            <h2 class="mb-3 menu-title">BILLING</h2>
                        </div>
                        <div class="text-left">
                            <div class="item" :class="$store.state.page == 'billingAddress' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('billingAddress')">Billing Address</div>
                            <div class="item mt-1" :class="$store.state.page == 'invoices' ? 'active font-weight: bold' : ''" @click.prevent.stop="changeComponent('invoices')">Invoices</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-15">
                <div class="d-flex justify-content-start align-items-center logout-btn" style="gap: 10px">
                    <img class="icons" src="../../../assets/img/s-5.svg" height="39" width="34" alt="Logout - icon" />
                    <div @click.prevent.stop="submitLogout()">Logout</div>
                </div>
            </div>
        </v-sheet>
    </div>
</template>

<script>
export default {
    props: {
        array: Array,
        current: String,
    },

    components: { },

    data() {
        return {
            companyMenu: true,
            sourcingMenu: true,
            billingMenu: true,
            adminPanel: true,
            actual: null,
            company_id: null,
            company: {},
            enablePopup: false,
            type: null,
        }
    },

    methods: {
        changeComponent(value) {
            this.$store.commit("UPDATE_PAGE", value);
            this.actual = value;
            this.$emit('changeComponent', value);
        },
        
        /**
         * @param $val // initial updated
         * @param $application // Investor Company
         */
        openAlertPopup(val, application) {
            this.type = val;
            this.$emit('openAlertPopupDownload', val, application);
        },

        async submitLogout() {
            await this.$store
                .dispatch("logout", {})
                .then((response) => {
                //console.log("logout success");
                })
                .catch((error) => {});
        },
    },

    created() {
        this.actual = this.$store.state.page;
    }
}
</script>

<style>
   
    .companyName {
        position: absolute;
        width: 235px !important;
        margin-left: -2px !important;
    }
    .link:hover {
        cursor: pointer;
    }
    .main-content {
        position: relative !important;
        background: #F7F7F7 !important;
        display: flex;
        flex-direction: column;
        padding: 45px 26px 0px 26px;
        width: 270px;
        box-sizing: border-box;
    }
    .form-control.search {
        border-radius: 16px;
        background: rgba(0, 168, 194, 0.86);
        margin-bottom: 64px;
        display: flex;
        flex-direction: row;
        align-self: flex-start;
        padding: 16px 0 16px 16px;
        width: 218px;
        box-sizing: border-box;
    }
    .menu-content .item:hover, .logout-btn:hover {
        color: rgba(0, 168, 194, 0.86);
        cursor: pointer;
    }
    .item.active {
        color: rgba(0, 168, 194, 0.86) !important;
    }

    .menu-title {
        font-weight: 700;
        font-size: 20px;
    }

    .logout-btn {
        cursor: pointer;
        transition: ease all 0.5ms;
    }
    
    @media only screen and (max-width: 959px) {
        .companyName {
            justify-content: center !important;
            margin-top: -22px;
        }
        .billing span {
            margin-right: 50px !important;
        }
        .subMenu {
            text-align: left !important;
        }
    }
</style>